module.exports = __webpack_public_path__ + "img/nucleus-logo-color.5066c7ff.png";